module.exports = __webpack_public_path__ + "img/Cameroon.35bf96d1.gif";